import { useInstantSearch } from 'react-instantsearch';

type Result = ModelHookResult<{
	isLoading: boolean;
}>;

export function useMobileFilters(): Result {
	const { results } = useInstantSearch();

	return {
		data: {
			isLoading: !!results.__isArtificial,
		},
	};
}
